export enum CreditRating {
'Excellent' = 710,
'Good' = 650,
'Poor' = 500
}